import React, { Component } from 'react';
import { connect } from 'react-redux';

import { hideInfoBox } from './actions.js';

import './style.css';
import './mobile.css';
class InfoBox extends Component {

  render() {
    let classString = null;
    if (this.props.infoBox.show) {
      classString = "mx-infobox-content show " + this.props.infoBox.boxType;
    } else {
      classString = "mx-infobox-content " + this.props.infoBox.boxType;
    }
    return (
      <div className="mx-infobox-wrapper">
        <div className={classString}>
          <div
            onClick={this.props.hideInfoBox}
            dangerouslySetInnerHTML={{ __html: this.props.infoBox.message }}
          >
          </div>
        </div>
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    infoBox: state.infoBox
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    hideInfoBox: () => dispatch(hideInfoBox())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(InfoBox);


// WEBPACK FOOTER //
// ./src/components/InfoBox/index.js